import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    height: '100%',
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    padding: [15, 15, 0],
    paddingTop: 15,
    [theme.breakpoints.up('mobile')]: {
      margin: 0,
      padding: 0,
      height: 'calc(100% - 132px)',
    },
  },
  nextBox: {
    boxShadow: 'rgb(0 0 0 / 12%) 0px 6px 16px 0px',
    border: `1px solid ${theme.palette.colors.divider}`,
    borderRadius: theme.spacing(1),
    marginBottom: 15,
    padding: 20,
    [theme.breakpoints.up('mobile')]: {
      boxShadow: 'none',
      borderRadius: 0,
      marginBottom: 0,
    },
  },
  nextStepsHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  nextIcon: {
    color: theme.palette.colors.yellow,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficersChatList/useStyles.js